<div *ngIf="params?.hasChildren" class="expand-menu" (click)="onExpandClick()">
  <button motifIconButton type="undefined" class="d-block" aria-label="Expand or collapse row" [attr.aria-expanded]="params?.isExpanded">
    <motif-icon
     class="d-block" 
    *ngIf="!params?.isExpanded"
    [iconFunction]="expandIcon"
    size="20"></motif-icon>
    <motif-icon
      *ngIf="params?.isExpanded"
      [iconFunction]="collapseIcon"
      size="20"
       class="d-block"></motif-icon>
  </button>
</div>
<div *ngIf="!params?.hasChildren">
  <!-- No icon for rows without children -->
</div>
